import React, { Component } from 'react'
import {connect} from 'react-redux'
import moment from 'moment'

import { loadFiscalyear, changeFiscalyear } from '../../actions/FiscalYear'
import { loadBalance } from '../../actions/Balance'
import { loadCourses } from '../../actions/Courses'
import { loadMembers } from '../../actions/Members'
import { loadReceipts } from '../../actions/Receipts'

const initialState = {
  year: ''
}

class FiscalYear extends Component {
  constructor () {
    super()
    this.state = initialState
  }
  changeYear (event) {
    this.setState({ year: event.target.value })
    this.props.changeFiscalyear(event.target.value)

    this.props.loadBalance()
    this.props.loadCourses()
    this.props.loadMembers()
    this.props.loadReceipts()
  }
  componentWillMount () {
    if (this.props.fiscalyear.list === null) {
      this.props.loadFiscalyear()
    } else {
      this.setState({ year: this.props.fiscalyear.current })
    }
  }
  // componentDidUpdate (prevProps, prevState) {
  //   console.log(prevProps.fiscalyear.current, this.props.fiscalyear.current)
  //   if (prevProps.fiscalyear.current !== this.props.fiscalyear.current) {
  //   }
  // }
  render () {
    const { list } = this.props.fiscalyear
    return (
      <label>
        Anno fiscale
        <select
          onChange={event => this.changeYear(event)}
          value={this.state.year}
          className="sel-fy"
        >
          {
            list !== null && (
              list.map((y, index) => {
                return (
                  <option key={index} value={y.id}>{moment.unix(y.start_date).format('MMM YYYY')} - {moment.unix(y.end_date).format('MMM YYYY')}</option>
                )
              })
            )
          }
        </select>
      </label>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { loadFiscalyear, changeFiscalyear, loadBalance, loadCourses, loadMembers, loadReceipts })(FiscalYear)



// WEBPACK FOOTER //
// ./src/components/Bone/FiscalYear.js